import { __awaiter } from "tslib";
import getMatchingLocale from './util/getMatchingLocale';
import { loadIntlWithLocale } from './intlLoaders';
import TextResolver from './TextResolver';
function registerLocale(resolver, localeName, locales, defaultLocale, defaultLocaleOverrides) {
    return __awaiter(this, void 0, void 0, function* () {
        const loader = getMatchingLocale(localeName, locales, defaultLocaleOverrides, defaultLocale);
        const locale = yield loader();
        resolver.registerTranslations(locale.default, 'default', localeName);
        return locale;
    });
}
function registerLocaleSync(resolver, localeName, locales, defaultLocale, defaultLocaleOverrides) {
    const loader = getMatchingLocale(localeName, locales, defaultLocaleOverrides, defaultLocale);
    const locale = loader;
    resolver.registerTranslations(locale, 'default', localeName);
}
export function initializeLocalization(locale, locales, textResolverOptions, defaultLocale, defaultLocaleOverrides) {
    return __awaiter(this, void 0, void 0, function* () {
        const textResolver = new TextResolver(Object.assign({ locale, context: 'default' }, textResolverOptions));
        const loadIntlWithLocalePromise = Promise.all([
            new Promise(resolve => loadIntlWithLocale(locale, resolve))
        ]);
        const [localeObject] = yield Promise.all([
            registerLocale(textResolver, locale, locales, defaultLocale, defaultLocaleOverrides),
            loadIntlWithLocalePromise
        ]);
        return { textResolver, localeObject };
    });
}
export function initializeLocalizationSync(locale, locales, textResolverOptions, defaultLocale, defaultLocaleOverrides) {
    const textResolver = new TextResolver(Object.assign({ locale, context: 'default' }, textResolverOptions));
    registerLocaleSync(textResolver, locale, locales, defaultLocale, defaultLocaleOverrides);
    return textResolver;
}
//# sourceMappingURL=localization.js.map